<div>
  <div class="modal-header">{{'dso-selector.select.collection.head' | translate}}
    <button type="button" class="close" (click)="closeCollectionModal()" aria-label="Close">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <ds-loading *ngIf="isLoading()"></ds-loading>
    <ds-collection-dropdown [ngClass]="{'d-none': isLoading()}"
                            (selectionChange)="selectObject($event)"
                            (searchComplete)="searchComplete()"
                            (theOnlySelectable)="theOnlySelectable($event)"
                            [entityType]="entityType">
    </ds-collection-dropdown>
  </div>
</div>
